import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";

export const StyledToggleSwitch = styled(FlexDiv)``;

export const StyledToggleInput = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;
  &:checked + label {
    background: ${theme.colorsV2.success.shade_600};
  }
  &:checked + label:after {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }
`;

export const StyledLabel = styled.label`
  cursor: pointer;
  text-indent: -9999px;
  width: 36px;
  height: 24px;
  background: ${theme.colorsV2.gray.shade_600};
  display: block;
  border-radius: 24px;
  position: relative;
  margin: 0;
  &:after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 20px;
    transition: 0.3s;
  }
`;
